import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MessageCircle, Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { API_URL } from '../../constants';

const ChatLoginPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email:'', password:'' });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/chat/login/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: form.email, password: form.password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || data.detail || 'Login failed.');
      localStorage.setItem('chat_token', data.token);
      localStorage.setItem('chat_username', data.username);
      navigate('/chatroom');
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full overflow-hidden">
        <div className="bg-emerald-700 text-white p-8 text-center">
          <MessageCircle className="w-16 h-16 mx-auto mb-3" />
          <h1 className="text-2xl font-bold">Sign in to Chatroom</h1>
          <p className="text-emerald-200 text-sm mt-1">Welcome back to the Gbongan community</p>
        </div>

        <div className="p-8">
          {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-sm mb-5">{error}</div>}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input type="email" required value={form.email} onChange={e => setForm(p=>({...p,email:e.target.value}))}
                  placeholder="your@email.com"
                  className="w-full pl-9 pr-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500" />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input type={showPw ? 'text' : 'password'} required value={form.password} onChange={e => setForm(p=>({...p,password:e.target.value}))}
                  placeholder="Your password"
                  className="w-full pl-9 pr-10 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500" />
                <button type="button" onClick={() => setShowPw(p=>!p)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                  {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading}
              className="w-full bg-emerald-700 text-white py-3 rounded-xl font-semibold hover:bg-emerald-800 transition disabled:opacity-60 mt-2">
              {loading ? 'Signing in…' : 'Sign In to Chatroom'}
            </button>
          </form>

          <div className="mt-5 text-center">
            <p className="text-sm text-gray-600">Don't have an account?{' '}
              <Link to="/chatroom/register" className="text-emerald-700 font-semibold hover:underline">Register here</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatLoginPage;
